import auth from '../auth/authenticate';
import BusinessApi from './BusinessApi';

export const getCustomerProductSelections = (contractId) => {
    const roleId = auth.getRoleId();
    const accountId = auth.getUserId();

    return {
        type: "GET_CUSTOMER_PRODUCT_SELECTIONS",
        payload: BusinessApi.get(`/api/${accountId}/${roleId}/customer-product-selections?contractId=${contractId}`)
    };
}

export const createCustomerProductSelection = (request) => {
    const roleId = auth.getRoleId();
    const accountId = auth.getUserId();

    return {
        type: "CREATE_CUSTOMER_PRODUCT_SELECTION",
        payload: BusinessApi.post(`/api/${accountId}/${roleId}/customer-product-selections`, request)
    };
}

export const updateCustomerProductSelection = (request) => {
    const roleId = auth.getRoleId();
    const accountId = auth.getUserId();

    return {
        type: "UPDATE_CUSTOMER_PRODUCT_SELECTION",
        payload: BusinessApi.put(`/api/${accountId}/${roleId}/customer-product-selections/${request.id}`, request)
    };
}